import {
  useFormContext,
} from 'react-hook-form';
import {
  ClaimDataForm,
} from 'pages/Dashboard/pages/Billing/types';
import {
  useGetPatientInsurances,
} from 'views/EMR/components/Insurance/hooks';
import {
  isNilOrZero,
 notEmptyString,
} from '@populateui/utils';

const INSURANCE_NOT_SET_REASON = 'Insurance is not set';

export type ClaimSubmitCapability = {
  canTransmit: boolean;
  canMarkSubmitted: boolean;
  transmitDisabledReason?: string;
  markSubmittedDisabledReason?: string;
};

function getTransmitDisabledReason(
  hasInsurance: boolean,
  proClaimsMessage?: string | null,
): string | undefined {
  const insuranceReason = !hasInsurance ? INSURANCE_NOT_SET_REASON : undefined;
  const proClaimsReason = notEmptyString(proClaimsMessage) ? (proClaimsMessage ?? '') : undefined;

  return insuranceReason ?? proClaimsReason;
}

export function useClaimSubmitCapability(
  patientId?: number,
): ClaimSubmitCapability {
  const { watch } = useFormContext<ClaimDataForm>();
  const insurance = watch('insurance');
  const { data: patientInsurances } = useGetPatientInsurances(patientId ?? 0);

  const insuranceId = insurance?.insuranceId ?? 0;
  const hasInsurance = !isNilOrZero(insuranceId);
  const selectedInsurance = patientInsurances?.find(
    (patientInsurance) => patientInsurance.insuranceId === insuranceId,
  ) ?? insurance;

  const {
    proClaims: supportsProClaims = true,
    proClaimsMessage,
  } = selectedInsurance?.payerEntry?.ediSupport ?? {};

  return {
    canTransmit: hasInsurance && supportsProClaims,
    canMarkSubmitted: hasInsurance,
    transmitDisabledReason: getTransmitDisabledReason(hasInsurance, proClaimsMessage ),
    markSubmittedDisabledReason: hasInsurance ? undefined : INSURANCE_NOT_SET_REASON,
  };
}
